/*!
 * Copyright (c) 2024 Digital Bazaar, Inc. All rights reserved.
 */
export const BLIND_API_ID = 'BLIND_H2G_HM2S_';
export const CORE_API_ID = 'H2G_HM2S_';
export const PSEUDONYM_API_ID = 'H2G_HM2S_PSEUDONYM_';
